<nts-base-enum-text-box #baseEnumTextBox [value]="value" [options]="filteredValues" [appendTo]="'body'"
    [isDisabled]="!filter.isEnabled || !propertyViewModel.enabled"
    [placeholder]="placeholder" optionLabel="description" dataKey="key" (onChange)="onChange($event)"
    (onBlur)="onBlur()">
</nts-base-enum-text-box>
